import { Banner } from 'component/banner'
import sizeImg from 'image/sizeR1.png'
import './product.less'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { PlayCircleOutlined } from '@ant-design/icons';
import { ConfigProvider, Modal, Space } from 'antd';
import { useEffect, useState } from 'react';
import { post } from 'request/request';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectLocale } from 'store/localeSlice';
import { FullScreenModal } from 'component/modal';

export const ProductR1 = () => {
    const [isModalVisible, setModalVisible] = useState(false)
    const [loopModalVisible, setLoopModalVisible] = useState(false)
    const intl = useIntl();
    const locale= useSelector(selectLocale);

    const [curVideo, setCurVideo] = useState('')
    const [loopList, setLoopList] = useState([])
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const isMobile = navigator.userAgent.match(/(Mobi|Android|iPhone)/i);
    const videoUrl = 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/16981519405664449.m4v';

    const imgBanner = [
    {
        title: intl.formatMessage({id: 'productR1.imgBanner.title1'}),
        content: intl.formatMessage({id: 'productR1.imgBanner.con1'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000174631498943.png'
    },
    {
        title: intl.formatMessage({id: 'productR1.imgBanner.title2'}),
        content: intl.formatMessage({id: 'productR1.imgBanner.con2'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000174941832663.png'
    },
    {
        title: intl.formatMessage({id: 'productR1.imgBanner.title3'}),
        content: intl.formatMessage({id: 'productR1.imgBanner.con3'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000175250659631.png'
    },
    {
        title: intl.formatMessage({id: 'productR1.imgBanner.title4'}),
        content: intl.formatMessage({id: 'productR1.imgBanner.con4'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000175516699786.png'
    },
    {
        title: intl.formatMessage({id: 'productR1.imgBanner.title5'}),
        content: intl.formatMessage({id: 'productR1.imgBanner.con5'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000175682025147.png'
    }
    ]
    const proList = [
        {
            title: intl.formatMessage({id: 'productR1.proList.title1'}),
            content: intl.formatMessage({id: 'productR1.proList.con1'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000309790696886.png'
        },
        {
            title: intl.formatMessage({id: 'productR1.proList.title2'}),
            content: intl.formatMessage({id: 'productR1.proList.con2'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000310013048826.png'
        }
        ]
    const proList2 = [
        {
            title: intl.formatMessage({id: 'productR1.proList2.title1'}),
            content: intl.formatMessage({id: 'productR1.proList2.con1'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000312320743597.png'
        },
        {
            title: intl.formatMessage({id: 'productR1.proList2.title2'}),
            content: intl.formatMessage({id: 'productR1.proList2.con2'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000312652424922.png'
        },
        {
            title: intl.formatMessage({id: 'productR1.proList2.title3'}),
            content: intl.formatMessage({id: 'productR1.proList2.con3'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000312853549694.png'
        }
    ]
    const specificationList1 = [
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title1'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con1'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title2'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con2'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title3'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con3'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title4'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con4'})
        },
        // {
        //     name: intl.formatMessage({id: 'productR1.specificationList.title5'}),
        //     con: intl.formatMessage({id: 'productR1.specificationList.con5'})
        // },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title6'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con6'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title7'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con7'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title8'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con8'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title9'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con9'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title10'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con10'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title11'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con11'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title12'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con12'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title13'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con13'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title14'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con14'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title15'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con15'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title16'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con16'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title17'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con17'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title18'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con18'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title19'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con19'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title20'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con20'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title21'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con21'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title22'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con22'})
        }
    ]
    const specificationList2 = [
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title26'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con26'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title27'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con27'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title28'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con28'})
        },
        {
            name: intl.formatMessage({id: 'productR1.specificationList.title29'}),
            con: intl.formatMessage({id: 'productR1.specificationList.con29'})
        }
    ]
    useEffect(() => {
        post('snailcar/website/common/queryReview',{pageNo: 1,pageSize: 999}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setLoopList(data.resultBody.data.list)
            }
        })
    }, [])
    return <div className="product-container">
        <div className="product-banner">
            <img className='pc-block' style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000156906572759.png" alt="" />
            <img className='mobile-block' style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17004639530631836.png" alt="" />
            <div className='product-title'>
                <p>{intl.formatMessage({id: 'productR1.title'})}</p>
                {/* <p>{intl.formatMessage({id: 'homeR1.price.num'})}</p> */}
            </div>
            <div className='paly-btn' onClick={() => setModalVisible(true)}>
                <Space><PlayCircleOutlined /><span>{intl.formatMessage({id: 'product.play.btn'})}</span></Space>
            </div>
        </div>
        <div className='banner-wrapper'>
            <div className='banner-title'>
                <div className='title'>{intl.formatMessage({id: 'productR1.banner.title1'})}</div>
                <div className='content'>{intl.formatMessage({id: 'productR1.banner.con1'})}</div>
            </div>
            <Banner data={imgBanner} type="1"></Banner>
            <div className='pro-detail-wrapper'>
                <div className='banner-title banner-title2' >{intl.formatMessage({id: 'productR2.Exclusive.Features'})}</div>
                <div className='pro-list'>
                    {proList.map((item,index) => <div key={index} className='pro-item'>
                        {index%2===0 && <img className='middle-block' src={item.url} alt="" />}
                        <img className='middle-block-none' src={item.url} alt="" />
                        <div className='con-wrapper'>
                            <div>
                                <div className='title'>{item.title}</div>
                                <div className='content'>{item.content}</div>
                            </div>
                        </div>
                        {index%2!==0 && <img className='middle-block' src={item.url} alt="" />}
                    </div>)}
                </div>
            </div>
            <div className='product-banner2 pro-spec-wrapper'>
                <img src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17004657157196177.png" alt="" />
                <div className='banner-con pro-spec-con'>{intl.formatMessage({id: 'productR1.banner.title3'})}</div>
            </div>
        </div>
        <div className='pro-list2' style={{marginTop: '0'}}>
            {proList2.map((item,index:number) => <div key={index} className='pro-item'>
                {index%2===0 && <div className='img-wrapper middle-block-none'><img src={item.url} alt="" /></div>}
                <div className='img-wrapper middle-block'><img src={item.url} alt="" /></div>
                <div className='con-wrapper'>
                    <div>
                        <div className='title'>{item.title}</div>
                        <div className='content'>{item.content}</div>
                    </div>
                </div>
                {index%2!==0 && <div className='img-wrapper middle-block-none'><img src={item.url} alt="" /></div>}
            </div>)}
        </div>
        <div className='banner-wrapper'>
            <div>
                <div className='banner-title spec-title'>{intl.formatMessage({id: 'product.banner.con3'})}</div>
                <div className='specification-wrapper specification-block-wrapper'>
                    <div className='spec-right-img'>
                        <img src={sizeImg} alt="" />
                    </div>
                    <ul className='spec-ul'>
                        <li className='title'>{intl.formatMessage({id: 'productR1.specificationList.information'})}</li>
                        {specificationList1.map((item,index) => <li key={index} className='spec-li'>
                            <span className='name'>{item.name}</span>
                            <span className='com'>{item.con}</span>
                        </li>)}
                        {/* <li className='title'>{intl.formatMessage({id: 'productR1.specificationList.Package&LoadingQty'})}</li>
                        {specificationList2.map((item,index) => <li key={index} className='spec-li'>
                            <span className='name'>{item.name}</span>
                            <span className='com'>{item.con}</span>
                        </li>)} */}
                    </ul>
                </div>
            </div>
            <div className='banner-title loop-title'>{intl.formatMessage({id: 'product.customerReviews'})}</div>
            <div className='middle-block-none'>
                <Slider {...settings}>
                    {
                        loopList.map((item:any,index) => <div key={index}>
                            <div className='loopList-item'>
                                <div className='img-div' onClick={() => {setCurVideo(item.video);isMobile ? (window.location.href = item.video) : setLoopModalVisible(true)}}><img src={item.image} alt="" /><PlayCircleOutlined className='icon'/></div>
                                <div style={{flex: 1}}>
                                    <div className='title'>{item.name}</div>
                                    {/* <div className='time'>{item.time}</div> */}
                                    <div className='con'>{item.des}</div>
                                </div>
                            </div>
                        </div>)
                    }
                </Slider>
            </div>
        </div>
        <div className='pro-list2 middle-block' style={{marginTop: 40}}>
            {loopList.map((item:any,index:number) => <div key={index} className='pro-item'>
                <div className='img-div'  onClick={() =>  {setCurVideo(item.video);setLoopModalVisible(true)}}><img src={item.image} alt="" /><PlayCircleOutlined className='icon'/></div>
                <div className='con-wrapper'>
                    <div>
                        <div className='title'>{item.name}</div>
                        <div className='content'>{item.des}</div>
                    </div>
                </div>
            </div>)}
        </div>
        {/* <ConfigProvider
        //   theme={{
        //     token: {
        //       colorPrimary: '#F6D3CE',
        //     },
        //   }}
        >
           {isModalVisible&&<Modal title="" open={isModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setModalVisible(false)}}>
		   <video webkit-playsinline="true" playsInline autoPlay style={{width: '100%',marginTop: 30}} controls={true} src={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/16981519405664449.m4v'} ></video>
          </Modal>}
          {loopModalVisible&&<Modal title="" open={loopModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setLoopModalVisible(false)}}>
		   <video style={{width: '100%',marginTop: 30}} webkit-playsinline="true" autoPlay playsInline controls={true} src={curVideo} ></video>
          </Modal>}
        </ConfigProvider> */}
        <FullScreenModal setOpen={setModalVisible} open={isModalVisible} url={videoUrl} />
        <FullScreenModal setOpen={setLoopModalVisible} open={loopModalVisible} url={curVideo} />
    </div>
}